import { useTranslation } from 'react-i18next';
import InputField from '../../../components/input';

export interface AddressDetails {
  short_address: string;
  building_number: string;
  secondary_number: string;
  street_name: string;
  district: string;
  postal_code: string;
}

interface NationalAddressFormProps {
  addressDetails: AddressDetails;
  onChange: (field: keyof AddressDetails, value: string) => void;
  errors?: any;
  hideTitle?: boolean;
}

export default function NationalAddressForm({
  addressDetails, onChange, errors, hideTitle = false,
}: NationalAddressFormProps) {
  const { t } = useTranslation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const finalValue = name === 'short_address' ? value.toUpperCase() : value;
    onChange(name as keyof AddressDetails, finalValue);
  };

  return (
    <div className={`${hideTitle ? '' : 'border-b border-gray-200 pb-6 mb-4'}`}>
      {!hideTitle && <h2 className='text-lg font-medium text-black mb-4'>{t('checkout.nationalAddress.title') || 'National Address'}</h2>}
      <div className='grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-4'>
        <div className='sm:col-span-2'>
          <InputField
            label={t('checkout.nationalAddress.shortAddress') || 'Short Address'}
            type='text'
            name='short_address'
            value={addressDetails.short_address}
            onChange={handleChange}
            errors={errors}
            placeholder='e.g. RRRD2929'
            required
            maxLength={8}
          />
        </div>
      </div>
    </div>
  );
}
